import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { useMutation } from '@apollo/client';
import { REQUEST_PASSWORD_RESET } from '../graphql/mutations';
import Layout from '../components/Layout';
import { Form, Button, Alert } from 'react-bootstrap';

const ForgotPassword: React.FC = () => {
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const [requestReset] = useMutation(REQUEST_PASSWORD_RESET);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    setMessage('');
    setLoading(true);

    try {
      const result = await requestReset({ variables: { email } });
      if (result.data?.requestPasswordReset?.success) {
        setMessage('Password reset link has been sent to your email.');
      } else {
        setError(result.data?.requestPasswordReset?.message || 'Failed to send reset link');
      }
    } catch (err: any) {
      setError(err.message || 'An error occurred');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Layout showSidebar={false}>
      <div className="d-flex align-items-center justify-content-center" style={{ minHeight: '60vh' }}>
        <div className="w-100" style={{ maxWidth: '448px' }}>
          <div className="bg-white rounded-4 shadow p-4 p-md-5">
            <div className="text-center mb-4">
              <h1 className="fw-bold text-dark fs-2 mb-2">Forgot Password</h1>
              <p className="text-secondary">Enter your email to reset your password</p>
            </div>

            {message && (
              <Alert variant="success" className="mb-3">
                {message}
              </Alert>
            )}

            {error && (
              <Alert variant="danger" className="mb-3">
                {error}
              </Alert>
            )}

            <Form onSubmit={handleSubmit} className="d-flex flex-column gap-4">
              <Form.Group>
                <Form.Label className="fw-medium text-secondary small">
                  Email Address
                </Form.Label>
                <Form.Control
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  className="px-3 py-2 border rounded-3"
                  required
                />
              </Form.Group>

              <Button
                variant="primary"
                type="submit"
                disabled={loading}
                className="w-100 py-2"
                style={{ opacity: loading ? 0.5 : 1 }}
              >
                {loading ? 'Sending...' : 'Send Reset Link'}
              </Button>
            </Form>

            <div className="mt-4 text-center">
              <p className="text-secondary">
                Remember your password?{' '}
                <Link to="/login" className="text-primary fw-medium text-decoration-none">
                  Sign in
                </Link>
              </p>
            </div>
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default ForgotPassword;
